// extracted by mini-css-extract-plugin
export default {"main_content":"index_main_content_mkf6i"};